import { createContext, useContext, useEffect, useState } from 'react';
import { getPlatformSettings, getSettings } from '../utils/api';

const PlatformContext = createContext({});

export function PlatformProvider({ children }) {
  const [settings, setSettings] = useState({
    minDepositCents: 0,
    minCashoutCents: 0,
    minSendCents:    0,
    feeBps:          50,
    feePct:          '0.50',
    maintenanceMode: false,
    loaded:          false
  });

  useEffect(() => {
    getPlatformSettings()
      .then(r => setSettings({ ...r.data, loaded: true }))
      .catch(console.error);
  }, []);

  async function refreshWithUserFee() {
    try {
      const [platform, userSettings] = await Promise.all([
        getPlatformSettings(),
        getSettings()
      ]);
      const effectiveFeeBps = userSettings.data.customFeeBps !== null && userSettings.data.customFeeBps !== undefined
        ? userSettings.data.customFeeBps
        : platform.data.feeBps;
      setSettings({
        ...platform.data,
        feeBps: effectiveFeeBps,
        feePct: (effectiveFeeBps / 100).toFixed(2),
        loaded: true
      });
    } catch (err) {
      console.error('Failed to refresh platform settings:', err);
    }
  }

  return (
    <PlatformContext.Provider value={{...settings, refreshWithUserFee}}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  return useContext(PlatformContext);
}
